module.exports = __webpack_public_path__ + "media/images/gallery/ce_on-1ff1f0260e9bb99f3ee03c6f0e65c418.gif";